module.exports = __webpack_public_path__ + "static/media/oneshelf-pic6.e362be1b.JPG";